import React from 'react'
import PreAuthScreen from '../../components/preAuth/PreAuthScreen'
import { Grid } from '@mui/material'
import Header from '../../Header'
import styled from 'styled-components'
import "../../styles/theme.scss"
import { useNavigate } from "react-router-dom";

export const PreAutharisation = () => {
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };


  const Content = styled("div")(({ theme }) => ({
    flexGrow: 1,
    // paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
    // transition: theme.transitions.create("margin", {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
    // Add margin top here
    // marginTop: theme.spacing(10), // Adjust the spacing as needed
  }));

  return (
    <Grid >
    <Header
      navigate={handleNavigation}
      children={
        <Content>
          <PreAuthScreen />
        </Content>
      }
    />
  </Grid>
  )
}
